import Homework from '../homework';

/**
 * Create the action
 */

const { thunk, request, success, error } = Homework.destroy((id, fetch) => {
    return fetch.delete(`homework/${id}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };